import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {AppVersion} from './app-version.model';
import {UpdateAvailableEvent} from '@angular/service-worker';
import { AuthService } from '~app/auth/auth.service';
import { merge } from 'lodash-es';
import { EncryptedDataService } from '~app/auth/encrypted-data.service';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {

  private appUpdates = new Subject<AppVersion>();
  public appUpdates$ = this.appUpdates.asObservable();

  constructor(private authService: AuthService) { }

  /**
   * Decrypts tenant specific data and merges it into the base object.
   * Public for testing purposes; shouldn't be used directly.
   */
  public async applyTenantData(appData: any, tenantID: number, key?: string): Promise<void> {
    const tenantData = appData.tenants?.[tenantID];
    if (tenantData) {
      merge(appData, await EncryptedDataService.decrypt(tenantData, key));
    }
    delete appData.tenants;
  }

  public async newAppVersionAvailable(event: UpdateAvailableEvent) {
    const appData: any = event.available.appData;
    if (appData) {
      this.applyTenantData(appData, this.authService.getTenant(), this.authService.getTenantKey());
      this.appUpdates.next(appData);
    }
  }
}
